import { FC } from 'react';
import { RsSelect, SelectDataType } from 'components/Rsuite/Select';

interface AgeRangeSelectionProps {
  options: SelectDataType<number>[];
  ageRange: [number, number];
  onAgeRangeChange: (newAgeRange: [number, number]) => void;
}

export const AgeRangeSelection: FC<AgeRangeSelectionProps> = ({
  options,
  ageRange,
  onAgeRangeChange,
}) => {
  return (
    <section className='flex flex-col'>
      <div className='flex items-center gap-[18px]'>
        <RsSelect
          className='w-[84px]'
          data={options}
          value={ageRange[0]}
          onChange={(newAgeMin) => {
            if (newAgeMin > ageRange[1]) {
              onAgeRangeChange([newAgeMin, newAgeMin]);
            } else {
              onAgeRangeChange([newAgeMin, ageRange[1]]);
            }
          }}
          cleanable={false}
        />
        ~
        <RsSelect
          className='w-[84px]'
          data={options}
          value={ageRange[1]}
          onChange={(newAgeMax) => {
            if (newAgeMax < ageRange[0]) {
              onAgeRangeChange([newAgeMax, newAgeMax]);
            } else {
              onAgeRangeChange([ageRange[0], newAgeMax]);
            }
          }}
          cleanable={false}
        />
      </div>
    </section>
  );
};
